export default __webpack_public_path__ + "static/map-d1aad7339ec89cbe5146ccbbaf977aad.jpg";